
import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class GeoApiService {

    constructor(private _http: HttpClient) { }

    public findByZip(zipCode) {
        return this._http.get(API_HOST + `geo/find-by-zip?zipCode=${zipCode}`)
    }
    public findByAddress(address) {
        return this._http.get(API_HOST + `geo/find-by-address?q=${address}`)
    }

    public getWeather(zipCode: string, state: string) {
        return this._http.get(API_HOST + `geo/weather?zipCode=${encodeURIComponent(zipCode)}&state=${encodeURIComponent(state)}`)
    }

    public getWeatherByCoords(lat: number, lng: number) {
        return this._http.get(API_HOST + `geo/weather-by-coords?lat=${lat}&lng=${lng}`)
    }

}